import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';

import { environment } from 'src/environments/environment';

/**
 * Page title update logic.
 */
@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  /**
   * Constructor.
   * @param title The title data.
   */
  constructor(private readonly title: Title) {
    super();
  }

  /**
   * Update the page title.
   * @param routerState Router state data.
   */
  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`${title ?? 'Loading...'} | ${environment.appName}`);
    }
  }
}
